import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bb83fefc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bb83fefc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb83fefc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb83fefc')) {
      api.createRecord('bb83fefc', component.options)
    } else {
      api.reload('bb83fefc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bb83fefc&scoped=true", function () {
      api.rerender('bb83fefc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/system/addStaff/index.vue"
export default component.exports